import configuration from '../configuration'

export const CLARITY_CONSENT_KEY = 'plusadvance.clarityConsent'
export const CLARITY_SCRIPT_ID = 'plusadvance-clarity'
const CONSENT_VERSION = 1
const CONSENT_DURATION = 180 * 24 * 60 * 60 * 1000

export function readClarityConsent () {
  try {
    const saved = JSON.parse(window.localStorage.getItem(CLARITY_CONSENT_KEY))
    // Una versione nuova o una scelta scaduta richiedono un nuovo consenso esplicito.
    if (saved && saved.version === CONSENT_VERSION &&
      typeof saved.analytics === 'boolean' && Number.isFinite(saved.expiresAt) &&
      saved.expiresAt > Date.now() && saved.expiresAt <= Date.now() + CONSENT_DURATION) {
      return saved
    }
  } catch (error) {
    // Dati corrotti o storage bloccato non autorizzano mai il caricamento di Clarity.
  }
  return null
}

export function saveClarityConsent (analytics) {
  const consent = { version: CONSENT_VERSION, analytics, expiresAt: Date.now() + CONSENT_DURATION }
  try {
    window.localStorage.setItem(CLARITY_CONSENT_KEY, JSON.stringify(consent))
    return consent
  } catch (error) {
    return null
  }
}

function clearClarityCookies () {
  // Rimuove anche i cookie della vecchia installazione, condivisi con i sottodomini.
  const parts = window.location.hostname.split('.')
  const domains = parts.map((part, index) => parts.slice(index).join('.'))
  for (const name of ['_clck', '_clsk']) {
    const expired = `${name}=; Max-Age=0; path=/`
    document.cookie = expired
    for (const domain of domains) {
      document.cookie = `${expired}; domain=${domain}`
      document.cookie = `${expired}; domain=.${domain}`
    }
  }
}

function sendConsent (analytics) {
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments)
  }
  window.clarity('consentv2', {
    analytics_Storage: analytics ? 'granted' : 'denied',
    ad_Storage: 'denied'
  })
}

export function syncClarityConsent (consent, canInitialize = true, options = configuration) {
  const analytics = consent && consent.analytics === true && consent.expiresAt > Date.now()
  // Riconosce anche uno script inserito dalla vecchia installazione, senza duplicarlo.
  const script = document.getElementById(CLARITY_SCRIPT_ID) || document.querySelector('script[src*="clarity.ms/tag/"]')
  if (!analytics) {
    if (typeof window.clarity === 'function') {
      window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' })
    }
    clearClarityCookies()
    // Il rifiuto API lascia attiva la raccolta senza cookie: serve un nuovo documento
    // per interrompere anche questa raccolta e annullare un eventuale script in download.
    return Boolean(script)
  }

  // Il consenso è globale, ma non estende le pagine che inizializzavano Clarity.
  if (!canInitialize || !options.clarityProjectId) return false
  if (script) {
    sendConsent(true)
    return false
  }
  // La scelta è in coda prima di scaricare lo script. Non chiediamo consenso pubblicitario.
  sendConsent(true)
  const tag = document.createElement('script')
  tag.id = CLARITY_SCRIPT_ID
  tag.async = true
  tag.src = `https://www.clarity.ms/tag/${encodeURIComponent(options.clarityProjectId)}`
  tag.onerror = () => tag.remove()
  document.head.appendChild(tag)
  return false
}

export function reloadAfterClarityRevocation () {
  window.location.reload()
}
